import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable'; 
import InventoryData from '../../Datas/InventoryData';

const AddMedIndent = ({ med, onClose, onAddToCart }) => {
  const [quantity, setQuantity] = useState(med.issueQuantity);
  const [rate, setRate] = useState(med.ratePerUnit);
  const [stockLevelMessage, setStockLevelMessage] = useState(null);

  const checkInventory = () => {
    const inventoryItem = InventoryData.find(item => item.name === med.name);
    
    if (inventoryItem) {
      setStockLevelMessage(
        <span style={{ color: 'green', fontWeight:'bold' }}>
          Your Stock Level: <span style={{ color: 'yellow' }}>{inventoryItem.tablets}</span> tablets available.
        </span>
      );
    } else {
      setStockLevelMessage(
        <span style={{ color: 'red', fontWeight:'bold' }}>
          No Stock of <span style={{ color: 'yellow' }}>{med.name}</span> is available in your inventory.
        </span>
      );
    }
  };

  React.useEffect(() => {
    checkInventory();
  },);

  const handleAddToCart = () => {
    onAddToCart(med.batchNumber, quantity, rate);
    onClose();
  };

  return (
    <div className="modal-overlay-indent-addmed" onClick={onClose}>
      <div className="modal-content-indent-addmed" onClick={(e) => e.stopPropagation()}>
        <h3>Edit Medicine Details</h3>
        <form>
          <div className="form-group">
            <label>Medicine Name</label>
            <input type="text" value={med.name} readOnly />
          </div>
          <div className="form-group">
            <label>Batch Number</label>
            <input type="text" value={med.batchNumber} readOnly />
          </div>
          <div className="form-group">
            <label>Rate/Unit (INR)</label>
            <input 
              type="number" 
              value={rate} 
              onChange={(e) => setRate(e.target.value)} 
            />
          </div>
          <div className="form-group">
            <label>Quantity</label>
            <input 
              type="number" 
              value={quantity} 
              onChange={(e) => setQuantity(e.target.value)} 
            />
          </div>

          {stockLevelMessage && (
            <div className="stock-info">
              <p>{stockLevelMessage}</p>
            </div>
          )}

          <div className="buttons-container">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="button" onClick={handleAddToCart}>Add to Departments Cart</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const IndentModal = ({ selectedWard, onClose }) => {
  const [showMedicineDetails, setShowMedicineDetails] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);

  const handleDownload = () => {
    if (!selectedWard) return;

    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text('Hospital Name', 105, 20, null, null, 'center'); 

    doc.setFontSize(12);
    doc.text(`Ward: ${selectedWard.wardName}`, 20, 40);
    doc.text(`Request Docker No.: ${selectedWard.requestDockerNo}`, 20, 50);
    doc.text(`Issue Date: ${selectedWard.issueDate}`, 20, 60);
    doc.text(`Request Date: ${selectedWard.requestDate}`, 20, 70);

    const headers = ['Batch ID', 'Medicine Name', 'Expiry Date', 'Rate/Unit', 'Stock Level', 'Issue Quantity', 'Cost (INR)'];
    const rows = selectedWard.medicines.map(med => [
      med.batchNumber,
      med.name,
      med.expiryDate,
      med.ratePerUnit,
      med.stockLevel,
      med.issueQuantity,
      med.cost
    ]);

    doc.autoTable({
      startY: 80, 
      head: [headers],
      body: rows,
      theme: 'grid',
      margin: { top: 30, left: 20, right: 20 },
      styles: {
        cellPadding: 2,
        fontSize: 10,
      }
    });

    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(12);
    doc.text('Authorized Signature: _____________', 110, pageHeight - 30); 
    doc.text('Date: ______________', 140, pageHeight - 20); 

    doc.save(`${selectedWard.wardName}_Indent.pdf`);
  };

  const handleAddMed = (medicine) => {
    setSelectedMedicine(medicine);
    setShowMedicineDetails(true);
  };

  const handleAddToCart = (batchNumber, quantity, rate) => {
    console.log(`Added to departments cart: ${batchNumber}, Quantity: ${quantity}, Rate: ${rate}`);
  };

  const getStockLevelClass = (stockLevel) => {
    if (stockLevel === 0) return 'red-stock';
    if (stockLevel === 1) return 'orange-stock';
    return '';
  };

  return (
    <div className="modal-overlay-indent" onClick={onClose}>
      <div className="modal-content-indent" onClick={(e) => e.stopPropagation()}>
        <div className="ward-info">
          <h3>{selectedWard.wardName} Ward</h3>
          <p><strong>Institute Type:</strong> Ward</p>
          <p><strong>Request Docker No.:</strong> {selectedWard.requestDockerNo}</p>
          <p><strong>Issue Date:</strong> {selectedWard.issueDate}</p>
          <p><strong>Request Date:</strong> {selectedWard.requestDate}</p>
        </div>

        <table className="medicines-table-indent">
          <thead>
            <tr>
              <th>Batch ID</th>
              <th>Medicine Name</th>
              <th>Expiry Date</th>
              <th>Rate/Unit (INR)</th>
              <th>Stock Available</th>
              <th>Issue Quantity</th>
              <th>Cost (INR)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {selectedWard.medicines.map((med, index) => (
              <tr key={index}>
                <td>{med.batchNumber}</td>
                <td>{med.name}</td>
                <td>{med.expiryDate}</td>
                <td>{med.ratePerUnit}</td>
                <td className={getStockLevelClass(med.stockLevel)}>{med.stockLevel}</td>
                <td>{med.issueQuantity}</td>
                <td>{med.cost}</td>
                <td>
                  <button
                    className="add-med-btn"
                    onClick={() => handleAddMed(med)}
                  >
                    Add Med
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="buttons-container">
          <button className="download-btn" onClick={handleDownload}>
            Download the Indent
          </button>
          <button className="show-details-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>

      {showMedicineDetails && (
        <AddMedIndent
          med={selectedMedicine}
          onClose={() => setShowMedicineDetails(false)}
          onAddToCart={handleAddToCart}
        />
      )}
    </div>
  );
};

export default IndentModal;
